export default "__VITE_ASSET__Kw3wJd_c__"